/* eslint-disable prefer-spread */
import { SVGParsedPathData } from "../../svg/SVGUtil";
import { YZCanvasContext } from "../../canvas";
import { L, TLOptions } from "./L";

export type TCubicBezierOptions = {
  c1x: number;
  c1y: number;
  c2x: number;
  c2y: number;
  toX?: number;
  toY?: number;
} & TLOptions;

export class CubicBezier extends L {
  public c1x: number;
  public c1y: number;
  public c2x: number;
  public c2y: number;

  constructor(options: TCubicBezierOptions) {
    super(options);
    this.c1x = options.c1x;
    this.c1y = options.c1y;
    this.c2x = options.c2x;
    this.c2y = options.c2y;
  }

  /// C c1x,c1y c2x,c2y x,y
  /// S c2x,c2y x,y
  toSVGPathData(): SVGParsedPathData[] {
    return [["C", this.c1x, this.c1y, this.c2x, this.c2y, this.toX, this.toY]];
  }

  toCanvasContext(ctx: YZCanvasContext) {
    ctx.bezierCurveTo(
      this.c1x,
      this.c1y,
      this.c2x,
      this.c2y,
      this.toX,
      this.toY
    );
  }

  getBoundingClientRect() {
    /// 一种方法
    // const tvalues = [];
    // const bounds: number[][] = [[], []];
    // let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
    // for (let i = 0; i < 2; ++i) {
    //   if (i === 0) {
    //     b = 6 * this.x - 12 * this.c1x + 6 * this.c2x;
    //     a = -3 * this.x + 9 * this.c1x - 9 * this.c2x + 3 * this.toX;
    //     c = 3 * this.c1x - 3 * this.x;
    //   } else {
    //     b = 6 * this.y - 12 * this.c1y + 6 * this.c2y;
    //     a = -3 * this.y + 9 * this.c1y - 9 * this.c2y + 3 * this.toY;
    //     c = 3 * this.c1y - 3 * this.y;
    //   }
    //   if (Math.abs(a) < 1e-12) {
    //     if (Math.abs(b) < 1e-12) {
    //       continue;
    //     }
    //     t = -c / b;
    //     if (t > 0 && t < 1) {
    //       tvalues.push(t);
    //     }
    //     continue;
    //   }
    //   b2ac = b * b - 4 * c * a;
    //   if (b2ac < 0) {
    //     continue;
    //   }
    //   sqrtb2ac = Math.sqrt(b2ac);
    //   t1 = (-b + sqrtb2ac) / (2 * a);
    //   if (t1 > 0 && t1 < 1) {
    //     tvalues.push(t1);
    //   }
    //   t2 = (-b - sqrtb2ac) / (2 * a);
    //   if (t2 > 0 && t2 < 1) {
    //     tvalues.push(t2);
    //   }
    // }
    // let j = tvalues.length;
    // let mt;
    // const jlen = j;
    // while (j--) {
    //   t = tvalues[j];
    //   mt = 1 - t;
    //   bounds[0][j] =
    //     mt * mt * mt * this.x +
    //     3 * mt * mt * t * this.c1x +
    //     3 * mt * t * t * this.c2x +
    //     t * t * t * this.toX;
    //   bounds[1][j] =
    //     mt * mt * mt * this.y +
    //     3 * mt * mt * t * this.c1y +
    //     3 * mt * t * t * this.c2y +
    //     t * t * t * this.toY;
    // }
    // bounds[0][jlen] = this.x;
    // bounds[1][jlen] = this.y;
    // bounds[0][jlen + 1] = this.toX;
    // bounds[1][jlen + 1] = this.toY;
    // bounds[0].length = bounds[1].length = jlen + 2;
    // const min = {
    //   x: Math.min.apply(0, bounds[0]),
    //   y: Math.min.apply(0, bounds[1])
    // };
    // const max = {
    //   x: Math.max.apply(0, bounds[0]),
    //   y: Math.max.apply(0, bounds[1])
    // };
    // return {
    //   x: min.x,
    //   y: min.y,
    //   width: max.x - min.x,
    //   height: max.y - min.y
    // };

    /// 另一种方法
    let a =
      this.c2x - 2 * this.c1x + this.x - (this.toX - 2 * this.c2x + this.c1x);
    let b = 2 * (this.c1x - this.x) - 2 * (this.c2x - this.c1x);
    let c = this.x - this.c1x;
    let t1 = (-b + Math.sqrt(b * b - 4 * a * c)) / 2 / a;
    let t2 = (-b - Math.sqrt(b * b - 4 * a * c)) / 2 / a;
    const y = [this.y, this.toY];
    const x = [this.x, this.toX];
    let dot;
    const dots = [];
    Math.abs(t1) > 1e12 && (t1 = 0.5);
    Math.abs(t2) > 1e12 && (t2 = 0.5);
    if (t1 >= 0 && t1 <= 1) {
      dot = this.interpolate(t1);
      x.push(dot.x);
      y.push(dot.y);
      dots.push({ X: dot.x, Y: dot.y });
    }
    if (t2 >= 0 && t2 <= 1) {
      dot = this.interpolate(t2);
      x.push(dot.x);
      y.push(dot.y);
      dots.push({ X: dot.x, Y: dot.y });
    }
    a = this.c2y - 2 * this.c1y + this.y - (this.toY - 2 * this.c2y + this.c1y);
    b = 2 * (this.c1y - this.y) - 2 * (this.c2y - this.c1y);
    c = this.y - this.c1y;
    t1 = (-b + Math.sqrt(b * b - 4 * a * c)) / 2 / a;
    t2 = (-b - Math.sqrt(b * b - 4 * a * c)) / 2 / a;
    Math.abs(t1) > 1e12 && (t1 = 0.5);
    Math.abs(t2) > 1e12 && (t2 = 0.5);
    if (t1 >= 0 && t1 <= 1) {
      dot = this.interpolate(t1);
      x.push(dot.x);
      y.push(dot.y);
      dots.push({ X: dot.x, Y: dot.y });
    }
    if (t2 >= 0 && t2 <= 1) {
      dot = this.interpolate(t2);
      x.push(dot.x);
      y.push(dot.y);
      dots.push({ X: dot.x, Y: dot.y });
    }
    // remove duplicate dots
    const dots2 = [];
    const l = dots.length;
    for (let i = 0; i < l; i++) {
      for (let j = i + 1; j < l; j++) {
        if (dots[i].X === dots[j].X && dots[i].Y === dots[j].Y) j = ++i;
      }
      dots2.push({ X: dots[i].X, Y: dots[i].Y });
    }
    const min = { x: Math.min.apply(Math, x), y: Math.min.apply(Math, y) };
    const max = { x: Math.max.apply(Math, x), y: Math.max.apply(Math, y) };
    return {
      x: min.x,
      y: min.y,
      width: max.x - min.x,
      height: max.y - min.y,
      dots: dots2 // these are the extrema points
    };
  }

  /// t (0.0 to 1.0) : The fraction of the overall duration of the path
  interpolate(t: number): { x: number; y: number } {
    return {
      x:
        Math.pow(1 - t, 3) * this.x +
        3 * Math.pow(1 - t, 2) * t * this.c1x +
        3 * Math.pow(1 - t, 1) * Math.pow(t, 2) * this.c2x +
        Math.pow(t, 3) * this.toX,
      y:
        Math.pow(1 - t, 3) * this.y +
        3 * Math.pow(1 - t, 2) * t * this.c1y +
        3 * Math.pow(1 - t, 1) * Math.pow(t, 2) * this.c2y +
        Math.pow(t, 3) * this.toY
    };
  }

  static base3(
    t: number,
    p1: number,
    p2: number,
    p3: number,
    p4: number
  ): number {
    const t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4;
    const t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
    return t * t2 - 3 * p1 + 3 * p2;
  }

  /**
   * Based on snap.svg bezlen() function
   * like getTotalLength(), approximate a cubic bézier length
   * https://github.com/adobe-webplatform/Snap.svg/blob/master/dist/snap.svg.js#L5786
   */
  static bezlen(
    x1: number,
    y1: number,
    x2: number,
    y2: number,
    x3: number,
    y3: number,
    x4: number,
    y4: number,
    z = 1 /// length: 0 ~ 1
  ): number {
    z = Math.max(0, Math.min(z, 1));
    const z2 = z / 2;
    const Tvalues = [
      -0.1252, 0.1252, -0.3678, 0.3678, -0.5873, 0.5873, -0.7699, 0.7699,
      -0.9041, 0.9041, -0.9816, 0.9816
    ];
    const Cvalues = [
      0.2491, 0.2491, 0.2335, 0.2335, 0.2032, 0.2032, 0.1601, 0.1601, 0.1069,
      0.1069, 0.0472, 0.0472
    ];
    let sum = 0;
    /// 12 = Tvalues.length = Cvalues.length
    for (let i = 0; i < 12; i++) {
      const ct = z2 * Tvalues[i] + z2;
      const xbase = this.base3(ct, x1, x2, x3, x4);
      const ybase = this.base3(ct, y1, y2, y3, y4);
      sum += Cvalues[i] * Math.sqrt(xbase * xbase + ybase * ybase);
    }
    return z2 * sum;
  }

  length(z = 1): number {
    return CubicBezier.bezlen(
      this.x,
      this.y,
      this.c1x,
      this.c1y,
      this.c2x,
      this.c2y,
      this.toX,
      this.toY,
      z
    );
  }

  /// get position on the curve (0..1)
  getTatLen(ll: number): number {
    const x1 = this.x;
    const y1 = this.y;
    const x2 = this.c1x;
    const y2 = this.c1y;
    const x3 = this.c2x;
    const y3 = this.c2y;
    const x4 = this.toX;
    const y4 = this.toY;
    if (ll < 0 || CubicBezier.bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
      return 0;
    }
    const t = 1;
    let step = t / 2;
    let t2 = t - step;
    let l = CubicBezier.bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
    while (Math.abs(l - ll) > 0.01) {
      step /= 2;
      t2 += (l < ll ? 1 : -1) * step;
      l = CubicBezier.bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
    }
    return t2;
  }

  /// Find dot coordinates on the given cubic bezier curve at the given t
  getPointAtSegmentLength(length: number) {
    const t = this.getTatLen(length);
    const t1 = 1 - t,
      t13 = Math.pow(t1, 3),
      t12 = Math.pow(t1, 2),
      t2 = t * t,
      t3 = t2 * t,
      x =
        t13 * this.x +
        t12 * 3 * t * this.c1x +
        t1 * 3 * t * t * this.c2x +
        t3 * this.toX,
      y =
        t13 * this.y +
        t12 * 3 * t * this.c1y +
        t1 * 3 * t * t * this.c2y +
        t3 * this.toY,
      mx =
        this.x +
        2 * t * (this.c1x - this.x) +
        t2 * (this.c2x - 2 * this.c1x + this.x),
      my =
        this.y +
        2 * t * (this.c1y - this.y) +
        t2 * (this.c2y - 2 * this.c1y + this.y),
      nx =
        this.c1x +
        2 * t * (this.c2x - this.c1x) +
        t2 * (this.toX - 2 * this.c2x + this.c1x),
      ny =
        this.c1y +
        2 * t * (this.c2y - this.c1y) +
        t2 * (this.toY - 2 * this.c2y + this.c1y),
      ax = t1 * this.x + t * this.c1x,
      ay = t1 * this.y + t * this.c1y,
      cx = t1 * this.c2x + t * this.toX,
      cy = t1 * this.c2y + t * this.toY,
      alpha = 90 - (Math.atan2(mx - nx, my - ny) * 180) / Math.PI;
    // (mx > nx || my < ny) && (alpha += 180);
    return {
      x: x, // x coordinate of the point
      y: y, // y coordinate of the point
      m: {
        x: mx, // x coordinate of the left anchor
        y: my // y coordinate of the left anchor
      },
      n: {
        x: nx, // x coordinate of the right anchor
        y: ny // y coordinate of the right anchor
      },
      start: {
        x: ax, // x coordinate of the start of the curve
        y: ay // y coordinate of the start of the curve
      },
      end: {
        x: cx, //  x coordinate of the end of the curve
        y: cy // y coordinate of the end of the curve
      },
      alpha: alpha // degree: angle of the curve derivative at the point
    };
  }
}

export default CubicBezier;
